import React from 'react';
import { IPage } from 'src/interfaces';
import { Container, LinkWrapper, MessageContainer, Title, RedirectButton } from './styles';

const NotFound: React.FC<IPage> = () => (
  <Container>
    <MessageContainer>
      <Title>Page not found</Title>
      <LinkWrapper to="/dashboard" end>
        <RedirectButton>Go to dashboard</RedirectButton>
      </LinkWrapper>
    </MessageContainer>
  </Container>
);

export default NotFound;
